import { Android, Apple, Language, Star } from '@mui/icons-material';
import React from 'react';
import { Link } from 'react-router-dom';
import ArrowImg from '../../assets/icon/arrow-multiples.svg';
import CountUp from 'react-countup';

const Projects = () => {

     const projects = [
          {
               name: "Kooie App",
               description: "A smart vault for digital assets.",
               logoIcon: require('../../assets/images/Kooie.png'),
               link: "https://kooie.com.au/",
               apple: 'https://apps.apple.com/in/app/kooie-real-estate/id6737144920',
               android: 'https://play.google.com/store/apps/details?id=com.kooie&hl=en_IN'
          },
          {
               name: "Nirol Sales",
               description: "Trusted partner in electrical product sales.",
               logoIcon: require('../../assets/images/NirolSales.png'),
               link: "https://nirolelectricals.in/",
               android: 'https://play.google.com/store/apps/details?id=com.nirol.sales'
          },
          {
               name: "CV Trade",
               description: "Trade crypto with confidence and speed.",
               logoIcon: require('../../assets/images/CVTrade.png'),
               link: "https://cvtrade.io",
               apple: '',
               android: 'https://appstorespy.com/android-google-play/com.crypto.cvtradexchange-trends-revenue-statistics-downloads-ratings'
          },
          {
               name: "Whotagg",
               description: "Instantly scan and identify real-world objects.",
               logoIcon: require('../../assets/images/whotagg.png'),
               link: "https://whotagg.com",
               android: 'https://apkpure.net/whotagg/com.jstech.whotagg'
          },
          {
               name: "Bitnetto",
               description: "Fast and secure crypto trading platform.",
               logoIcon: require('../../assets/images/Bitnetto.png'),
               link: "https://bitnetto.io/",
               apple: 'https://apps.apple.com/us/app/bitnetto/id6504752389',
          },
          {
               name: "Tomax App",
               description: "Simplifying modern crypto transactions.",
               logoIcon: require('../../assets/images/tomex.png'),
               link: "https://tomax.exchange/",
          },
          {
               name: "D App Wallet",
               description: "Work In Progress - Secure and user-friendly crypto wallet.",
               logoIcon: require('../../assets/images/logo.png'),
               // link: "#",
          },
          
          // {
          //      name: "JS Wallet",
          //      description: "A reliable wallet for crypto storage.",
          //      logoIcon: require('../../assets/images/js_logo.png'),
          //      link: "#",
          //      apple: '',
          //      android: ''
          // },
          // {
          //      name: "GTC App",
          //      description: "Your gateway to seamless crypto exchange.",
          //      logoIcon: 'https://gtcexchange.io/static/media/New_logo.cfde906b289053414307.png',
          //      link: "https://gtcexchange.io/",
          //      apple: '',
          //      android: ''
          // }
     ];



     const CounterIN = [
          {
               name: "Total Projects",
               value: "17",
               addLast: '+'
          },
          {
               name: "Successful Projects",
               value: "12",
               addLast: '+'
          },
          {
               name: "Project Time",
               value: "4",
               addLast: 'Week'
          }
     ];


     return (
          <>
               <section className='__projects' id='work'>
                    <div className='__p-head'>
                         <h2>Developer tools, reimagined</h2>
                         <p>We understand the challenges developers face. That’s why we build products that streamline workflows, eliminate friction, and empower developers to focus on what they do best: making great products.</p>
                    </div>

                    <div className='__project-center'>
                         <div className='__grid' style={{ "--lengthItem": projects.length + 1.5 }}>
                              <div className='column-in none-data'>
                                   <h4>Build Better <br /> Software, Faster</h4>
                                   <img src={ArrowImg} alt='arrow-icon' />
                              </div>

                              {projects.map((item, index) => (
                                   <div className='column-in project-data' key={index} >
                                        {/* <Link to={item.link} target='_blank' className="stretched-link"></Link> */}
                                        <div className='__pd-head'>
                                             <p><Star /> {index + 1}</p>
                                             <div className='__logo'>
                                                  <img src={item?.logoIcon} alt='logo-web' />
                                             </div>
                                        </div>
                                        <div className='__pd-info'>
                                             <h5> {item.name}</h5>
                                             <h6>@Native</h6>
                                             <p> {item.description}</p>

                                             <div className='__dj3'>
                                                  {item?.link && <Link to={item?.link} target='_blank'> <Language /></Link>}
                                                  {item?.apple && <Link to={item?.apple} target='_blank'> <Apple /></Link>}
                                                  {item?.android && <Link to={item?.android} target='_blank'> <Android /></Link> }
                                             </div>
                                        </div>
                                   </div>
                              ))}
                         </div>
                    </div>

                    <div className='__p-footer'>
                         <div className='counter'>
                              {CounterIN.map((item, index) => (
                                   <div className='count-item' key={index}>
                                        <h2> <CountUp end={item.value} /> <span className='count-last'>{item.addLast} </span></h2>
                                        <p> {item.name}</p>
                                   </div>
                              ))}
                         </div>
                    </div>




               </section>
          </>
     );
}

export default Projects;
